import "./Overview.css";
import dots from "../../assets/dots.svg";
import cardOne from "../../assets/card-one.svg";
import cardTwo from "../../assets/card-two.svg";
import cardThree from "../../assets/card-three.svg";
const Overview = () => {
  return (
    <section className="overview-section" id="one">
      <div className="container">
        <div className="overview-heading">
          <div className="section-tag">
            <img src={dots} alt="dots" />
            <p>Features</p>
          </div>
          <h2 className="overview-heading-h2">
            AI Governance Orchestrated from the Ground Up
          </h2>
          <p>
            Automate GRC operations with intelligent agents that monitor,
            assess, and act — in real time. Achieve resilience, reduce risk, and
            ensure regulatory alignment effortlessly.
          </p>
        </div>
        <div className="overview-content">
          <div className="row three-card-wrapper">
            <div className="col-12 col-lg-3 col-md-6 col-sm-6">
              <div className="card-wrapper">
                <div>
                  <img src={cardOne} alt="card-one-image" />
                </div>
                <h3>Agentic Oversight</h3>
                <p>
                  Autonomous agents track model behaviour, detect drift, and
                  surface risks — delivering recommendations without
                  interrupting workflows.
                </p>
              </div>
            </div>
            <div className="col-12 col-lg-3 col-md-6 col-sm-6">
              <div className="card-wrapper">
                <div>
                  <img src={cardTwo} alt="card-two-image" />
                </div>
                <h3>Regulatory Compliance Orchestration</h3>
                <p>
                  Automatically map global regulations like the EU AI Act, NIST
                  RMF, and ISO 42001 to your AI workflows, with audit-ready
                  documentation generated on demand.
                </p>
              </div>
            </div>
            <div className="col-12 col-lg-3 col-md-6 col-sm-6">
              <div className="card-wrapper">
                <div>
                  <img src={cardThree} alt="card-three-image" />
                </div>
                <h3>Explainability & Assurance</h3>
                <p>
                  Integrates with LIME, SHAP, and Truera to deliver clear,
                  human-readable insights into model decisions and compliance
                  status — for internal and external assurance.
                </p>
              </div>
            </div>
            <div className="col-12 col-lg-3 col-md-6 col-sm-6">
              <div className="card-wrapper">
                <div>
                  <img src={cardOne} alt="card-one-image" />
                </div>
                <h3>Vendor & LLM Governance</h3>
                <p>
                  Monitor third-party models and LLMs, detect misuse,
                  hallucinations, and policy violations across embedded AI
                  systems.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Overview;
